<template>
  <div>
    <app-nav></app-nav>
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-1"></div>
        <main class="col-sm-9 ml-sm-auto col-md-10 pt-3" role="main">
          <h5 class="text-left" >Liste des Iades travaillant au Cabinet</h5>
          <br>
          <div class="form-check row">
            <label class="form-check-label">
                <input class="form-check-input"  type="checkbox" id="checkbox" v-model="viewInactives" >
                Montrer aussi les iades inactifs
            </label>
          </div>
          <div class="row"> 
          </div>
          <div class="table-responsive row">
            <table class="table table-striped">
              <thead>
              <tr>        
                  <th>#</th>
                  <th>Nom</th>
                  <th>Prenom</th>
                  <th>Actif</th>               
                  <th></th>
              </tr>
              </thead>
              <tbody>
                  <tr v-for="iade in filteredIades()" :key="iade.id">          
                  <th>{{iade.id}}</th>     
                  <th>{{iade.nom}}</th>     
                
                  <td class="text-left">{{ iade.prenom }}</td>
                  <td class="text-left">{{ iade.actif ?"&#x2714;"  : "Non" }}</td>
                  <td><button class="btn btn-danger btn-sm" @click="deleteIade(iade.id)">Suppr.</button></td>
                  </tr>
              </tbody>
            </table>
          </div>
        </main>
      </div>
    </div>
  </div>
</template>
<script>
  import {filter} from 'lodash'
  import AppNav from '../AppNav'
  import {
    ALL_IADES,
    UPDATE_IADE
  } from '../../constants/iade'

  export default {
    name: 'iades',
    components: {
      AppNav
    },
    data() {
      return {  
        allIades: {},
        viewInactives: false
      }
    },
    apollo: {
      allIades: {
        query: ALL_IADES
      }  
    },
    methods: {
      filteredIades () {
        var self = this
        if (self.viewInactives === true) {
          return   self.allIades.nodes
        } else {    
          return filter(self.allIades.nodes, function (iade) { 
              return iade.actif === true
          })       
        }
      },
        /*
        Don't truly delete !
        */
      deleteIade(id){
        var self = this;
        this.$apollo.mutate({
          mutation: UPDATE_IADE,
          variables: {
            id: id,
            actif: false
          },
           refetchQueries: [{
                query: ALL_IADES
            }]     
        }).then((data) => {
            self.$router.push({name: 'Iades'})
        }).catch((error) => {
          // Error
          console.error(error)
        })
       }
    }
  }
</script>
<style scoped>
body {
    padding-top: 3.5rem;
}

h1 {
    margin-bottom: 20px;
    padding-bottom: 9px;
    border-bottom: 1px solid #eee;
}

.sidebar {
    position: fixed;
    top: 51px;
    bottom: 0;
    left: 0;
    z-index: 1000;
    padding: 20px;
    overflow-x: hidden;
    overflow-y: auto;
    /* Scrollable contents if viewport is shorter than content. */
    border-right: 1px solid #eee;
}


/* Sidebar navigation */

.sidebar {
    padding-left: 0;
    padding-right: 0;
}

.sidebar .nav {
    margin-bottom: 20px;
}

.sidebar .nav-item {
    width: 100%;
}

.sidebar .nav-item+.nav-item {
    margin-left: 0;
}

.sidebar .nav-link {
    border-radius: 0;
}

.placeholders {
    padding-bottom: 3rem;
}

.placeholder img {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
}

select option[data-default] {
    display: none;
}

.medecins-form{
    padding-bottom: 60px;
}
</style>



// WEBPACK FOOTER //
// iades.vue?3e5db596